import React from 'react';
import { AbconetApi } from '../General/AbconetApi';
import { ProductRow } from './ProductRow';
import Slider from "react-slick";
import ItemCard from '../Product/ProductCard';

export class ProductRelatedItemTab extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTabIndex: 0,
            relatedItemCollection: [],
            tabs: [
                {
                    label: 'Accessories',
                    itemList: [],
                    content: 'Accessories',
                },
                {
                    label: 'Parts',
                    itemList: [],
                    content: 'Parts',
                },
                {
                    label: 'Related Items',
                    itemList: [],
                    content: 'Related Items',
                },
                //{
                //    label: 'Product Info',
                //    itemList: [],
                //    content: 'Product Info',
                //},
            ],
        };
        this.logState = this.logState.bind(this);
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    componentDidMount() {
        AbconetApi.get(this.props.dataUrl).then((data) => {
            this.setState({ relatedItemCollection: data });
        }).then(() => { 
            if (!this.state.relatedItemCollection) {
                return;
            }

            let partsItemList = this.state.relatedItemCollection.filter((item) => {
                return item.itemClass == 112 && item.itemCategory == 77;
            });

            let accessoriesItemList = this.state.relatedItemCollection.filter((item) => {
                return item.itemClass == 112 && item.itemCategory != 77;
            });

            let relatedItemList = this.state.relatedItemCollection.filter((item) => {
                return item.itemClass != 112;
            })

            this.setState(prevState => {
                const updatedTabs = [...prevState.tabs];
                const productInfoTab = updatedTabs.find(tab => tab.label === 'Parts');
                productInfoTab.itemList = partsItemList;
                return { tabs: updatedTabs };
            });
            this.setState(prevState => {
                const updatedTabs = [...prevState.tabs];
                const productInfoTab = updatedTabs.find(tab => tab.label === 'Accessories');
                productInfoTab.itemList = accessoriesItemList;
                return { tabs: updatedTabs };
            });
            this.setState(prevState => {
                const updatedTabs = [...prevState.tabs];
                const productInfoTab = updatedTabs.find(tab => tab.label === 'Related Items');
                productInfoTab.itemList = relatedItemList;
                return { tabs: updatedTabs };
            });
        }).then(() => {
            let firstExistingTabIndex = this.state.tabs.findIndex((tab) => tab.itemList.length > 0);
            if (firstExistingTabIndex >= 0) {
                this.setState({ activeTabIndex: firstExistingTabIndex });
            }
        });
        
    }

    getCartItemFromItem(item) {
        if (this.props.cart) {
            for (var i = 0; i < this.props.cart.lines.length; i++) {
                var cartRow = this.props.cart.lines[i];
                if (cartRow.stockcode === item.stockcode) {
                    return cartRow;
                }
            }
        }
    }

    handleTabClick(index) {
        this.setState({ activeTabIndex: index });
    }

    logState() {
        console.log(this.state);
    }

    render() {
        const { activeTabIndex, tabs } = this.state;
        if ((this.props.title == "Recently Ordered" || this.props.title == "Most Ordered")
            && this.state.relatedItemCollection.length == 0) {
            return null;
        } else if (this.state.relatedItemCollection == null) {
            return null;
        }

        var isInfinite = true
        var isInfinite1024 = true;
        var isInfinite800 = true;


        if (this.state.relatedItemCollection.length < 4) {
            isInfinite = false;
        }

        if (this.state.relatedItemCollection.length < 3) {
            isInfinite1024 = false;
        }

        if (this.state.relatedItemCollection.length < 2) {
            isInfinite800 = false;
        }
        return (
            <div>
                {this.state.relatedItemCollection.length !== 0 && <div className='product-related-item-tab'>
                    <div className='tabs-container'>
                        <div className="tabs">
                            {this.state.tabs.map((tab, index) => {
                                if (tab.itemList.length == 0) {
                                    return
                                }
                                return <div
                                    key={index}
                                    className={index === activeTabIndex ? 'active-tab' : ''}
                                    onClick={() => this.handleTabClick(index)}
                                >
                                    {tab.label}
                                </div>
                            })}
                        </div>
                        <div className="tab-content">
                            {
                                this.state.tabs[activeTabIndex].itemList.length > 0 &&
                                    this.state.tabs[activeTabIndex].itemList.map((item, key) => {
                                        return <ProductRow
                                            key={"item-row-" + item.stockcode}
                                            item={item}
                                            canAddToCart={this.props.canAddToCart}
                                            limitOrderToApprovedStocklist={this.props.limitOrderToApprovedStocklist}
                                            limitOrderToTemplateStocklist={this.props.limitOrderToTemplateStocklist}
                                            showFullStockInfo={this.props.showFullStockInfo}
                                            disableItemReplacement={this.props.disableItemReplacement}
                                        />;
                                    })
                            }
                        </div>
                    </div>
                </div>}    
            </div>
            
        );
    }
}



